import { useEffect, useState } from "react";
import { api } from "../api";
import { Notice } from "../components/Layout";
import type { StaffIdentity } from "../types";
import { staffWorkspaceForRole } from "../app-routing";
import { AdminPage } from "./AdminPage";

export function StaffHomePage() {
  const [staff, setStaff] = useState<StaffIdentity | null>(null);
  const [error, setError] = useState("");
  useEffect(() => {
    api<{ ok: true; staff: StaffIdentity }>("/api/admin/whoami")
      .then((result) => setStaff(result.staff))
      .catch((reason) => setError(reason instanceof Error ? reason.message : "Staff sign-in required"));
  }, []);
  useEffect(() => {
    if (staff && staffWorkspaceForRole(staff.role) === "instructor") window.location.replace("/instructor");
  }, [staff]);
  if (error) return <main className="app-main"><Notice kind="error">{error}</Notice></main>;
  if (!staff || staff.role === "instructor") return <main className="app-main"><div className="loading-card">Opening staff workspace…</div></main>;
  return <AdminPage />;
}
